import { useState } from "react";

import { DangerButton } from "@components/buttons/DangerButton";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

import { TenantIsInactiveChangeDialog } from "./TenantIsInactiveChangeDialog";

export const ChangeIsInActiveButton = (tenant: Tenant) => {
  const [updateTenant, setUpdateTenant] = useState<boolean>(false);

  const { data: hasWritePermission } = usePermissionsCheckQuery(
    [
      Permissions.PltCatalogTenantActivate,
      Permissions.PltCatalogTenantDeactivate
    ],
    "or"
  );

  const modeText = tenant.isInactive ? "Activate" : "Deactivate";

  return (
    <>
      <TenantIsInactiveChangeDialog
        hidden={!updateTenant}
        tenant={tenant}
        onCancel={() => setUpdateTenant(false)}
      />

      <DangerButton
        text={modeText}
        onClick={() => setUpdateTenant(true)}
        styles={{ root: { width: "fit-content" } }}
        disabled={!hasWritePermission}
        title={!hasWritePermission ? NO_ACTION_PERMISSION : undefined}
      />
    </>
  );
};
